/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-30 11:15:29
 */

// 故障码维护-新增、编辑
const FaultCodeAddForm = {
    labelCol: { style: { width: '200px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        {
            name_lang:'account.tenant', // '租户'
            key:'sys_org_val',
            type:'select',
            required:true,
            width:'85%',
            options:[],
            placeholder_lang:'',
        },
        {
            name_lang:'faultData.fault_code', // '故障编码'
            key:'fault_code',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.protocol', // '协议'
            key:'protocol',
            type:'radio',   
            allowClear:true,
            required:true,
            options:[
                { label: 'PLC', value: '0' },
                { label: 'CAN', value: '1' },
            ]
        },
        {
            name_lang:'faultData.fault_status', // '故障状态'
            key:'fault_status',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit', // '故障限制'
            key:'fault_limit',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure', // '故障解决方案'
            key:'fault_measure',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            showuploadImg:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_de', // '故障状态（德语）'
            key:'fault_status_de',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_de', // '故障限制（德语）'
            key:'fault_limit_de',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_de', // '故障解决方案（德语）'
            key:'fault_measure_de',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_de_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_fr', // 故障状态（法语）
            key:'fault_status_fr',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_fr', // 故障限制（法语）
            key:'fault_limit_fr',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_fr', // 故障解决方案（法语）
            key:'fault_measure_fr',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_fr_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_nl', // 故障状态（荷兰语）
            key:'fault_status_nl',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_nl', // 故障限制（荷兰语）
            key:'fault_limit_nl',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_nl', // 故障解决方案（荷兰语）
            key:'fault_measure_nl',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_nl_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_et', // 故障状态（爱沙尼亚语）
            key:'fault_status_et',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_et', // 故障限制（爱沙尼亚语）
            key:'fault_limit_et',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_et', // 故障解决方案（爱沙尼亚语）
            key:'fault_measure_et',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_et_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_lv', // 故障状态（拉脱维亚语）
            key:'fault_status_lv',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_lv', // 故障限制（拉脱维亚语）
            key:'fault_limit_lv',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_lv', // 故障解决方案（拉脱维亚语）
            key:'fault_measure_lv',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_lv_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
        {
            name_lang:'faultData.fault_status_lt', // 故障状态（立陶宛语）
            key:'fault_status_lt',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
        },
        {
            name_lang:'faultData.fault_limit_lt', // 故障限制（立陶宛语）
            key:'fault_limit_lt',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:false,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'faultData.fault_measure_lt', // 故障解决方案（立陶宛语）
            key:'fault_measure_lt',
            type:'input',   
            allowClear:true,
            required:true,
            width:'85%',
            placeholder:'请输入',
            placeholder_lang:'base.enter',
            showAddBtn:true,
            showRemoveBtn:true,
            removeBtnDisabled:true,
            childKeyArr:[],
            addonBefore:'1.',
        },
        {
            name_lang:'', // '故障解决方案图片'
            key:'fault_measure_lt_img',
            type:'uploadImg',
            width:'85%',
            uploadImgData:{ // 上传图片配置
                accept:'.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif',
                action: '',
                imgList:[],
                title:'上传图片',
            }
        },
    ]
}


FaultCodeAddForm.formField.forEach(item=>{
    FaultCodeAddForm.formData[item.key] = ''
})

export {
    FaultCodeAddForm
}